// extracted by mini-css-extract-plugin
module.exports = {"rowsWrapper":"inquiriesReceived_rowsWrapper__jRPEl","row":"inquiriesReceived_row__cJHX9","rowInnerWrapper":"inquiriesReceived_rowInnerWrapper__zixrF"};